// import * as sessionApi from '@/api/sessionApi';
// import cda from './cda';
// import pdf from './pdf';
// import report from './report';
// import watch from './watch';
// import provider from './provider';
// import preferences from './preferences';

// import { setCsrf, setApplicationModel, LoggedOut,LoggedIn } from '@/mutation-types';
// import { RESET_TIMER } from '@/constants/event';

// import {ResumeFsm,NoResumeFsm,LoginFailure,LoginNavigation} from './fsm/messages';
// import * as messages from './fsm/messages';
// import Vue from 'vue';
// import { post } from '@/store/modules/fsm/index';
// import router from '@/router/index';
// import _ from 'lodash';

// import {
//   FEATURES
// } from '@/config';

// let { LoggedIn:LoggedInMessage } = messages;

// const state = {
//   phrData: null,
//   loggedIn: false,
//   sessionId: null,  //TODO: sessionId is not used at the moment
//   csrf: {
//     param: null,
//     token: null
//   }
// };

// const getters = {
//   getCsrf: state => state.csrf,
//   getAllData: state => state.phrData,
//   isLoggedIn: state => state.loggedIn,
//   getSessionId: state => state.sessionId,
//   getUser: state => {
//     return {...state.phrData.user, ...state.phrData.patient};
//   },
//   getTaxonomies: state => {
//     if(!FEATURES.cda_header_providers)
//       return _.pickBy(state.phrData.taxonomies,taxo=>_.some(taxo.npis,npi=>{
//         return state.phrData.npiGroupings[npi];
//       }));
//     else
//       return {...state.phrData.taxonomies};
//   },
//   getProviders: state => {
//     return {...state.phrData.npis};
//   },
//   getPatientRelations: state => {
//     return {...state.phrData.patient.relations}
//   },
// };

// const mutations = {
//   [setCsrf] (state,csrf) {
//     Vue.set(state,'csrf',csrf);
//   },
//   [setApplicationModel] (state,payload) {
//     Vue.set(state,'phrData',payload);
//   },
//   [LoggedOut] (state) {
//     Vue.set(state, 'phrData', null);
//     state.loggedIn = false;
//     state.sessionId = null;
//   },
//   [LoggedIn] (state, payload) {
//     Vue.set(state, 'phrData', payload.data);
//     state.loggedIn = true;
//   },
//   addMeasures (state, {externalMeasures,externalMeasCcdMeasIds,externalMeasCcds}) {
//     Vue.set(state.phrData, 'measures', {...state.phrData.measures,...externalMeasures});
//     Vue.set(state.phrData, 'ccds', {...state.phrData.ccds,...externalMeasCcds});
    
//     let measCcdMeasIds = state.phrData.measCcdMeasIds || [];
//     for (let measCcd in externalMeasCcdMeasIds) {
//       if (measCcdMeasIds[measCcd]) {
//         measCcdMeasIds[measCcd] = _.union(measCcdMeasIds[measCcd],externalMeasCcdMeasIds[measCcd]);
//       } else {
//         measCcdMeasIds[measCcd] = externalMeasCcdMeasIds[measCcd];
//       }
//     }
//     Vue.set(state.phrData, 'measCcdMeasIds', measCcdMeasIds);
    
//   }
// };
// const actions = {
//   updateCsrf({commit},csrf) {
//      commit(setCsrf,csrf);
//   },
//   inlineUpdateApplicationModel({commit},data) {
//     commit(setApplicationModel, data);
//   },
//   updateApplicationModel({commit}) {
//     return new Promise((resolve) => {
//       sessionApi.getAllData()
//       .then((applicationModel) => {
//         commit(setApplicationModel, applicationModel);
//         commit('watch/setExternalMeasuresLoaded',false);
//         resolve();
//       })
//       .catch((err) => {
//         console.error(err);
//       });
//     });
//   },
//   async showLoginPrompt({commit}) {
//     commit(LoggedOut);
//     router.push({name:LoginNavigation})
//   },
//   async getInitialMessage({commit}) {
//     let _message = { message : NoResumeFsm };
//     try {
//       let { data,instance,message,watch:watchValue } = await sessionApi.getInitialMessage(); 
//       if(message && message === 'resumeApplicationMessage'/** && state.loggedIn && state.phrData != null */ ) {
//         commit('watch/setExternalMeasuresLoaded', false);
//         _message = { message: ResumeFsm,data,instance,watch:watchValue };
//       } 
//     }
//     catch(err) {
//       alert(err);
//     }
//     return post(_message);
//   },
//   async login ({commit},{loader,patient,password,LoginPage}) {
//     let _message = {message:LoginFailure};
//     try {
//       let response = await sessionApi.login({patient,password});

//       commit('watch/setExternalMeasuresLoaded', false);
//       Vue.vueEventBus.$emit(RESET_TIMER,{ping:true});
//       _message = { ...response };
//       _message.message = LoggedInMessage;
//     }
//     catch(err) {
//       //TODO: 
//       LoginPage.statusMessage = err;
//       // LoginPage.statusMessage = 'Invalid login';
//     }
//     loader.hide();
//     post(_message);
//   },
//   async logout({commit}) {
//     try {
//       await sessionApi.logout();
//     }
//     catch(err) {
//       text = `error in trying to logout: ${err}`;
//       this.$swal({
//         type: 'error',
//         title: 'Unable to log out',
//         text
//       });
//       throw text;
//     } finally {
//       commit(LoggedOut);
//       commit('cda/clearCda');
//       commit('pdf/clearPdf');
//       commit('report/clearReport');
//       commit('watch/clearAllWatches');
//       //TODO: reset fsm ?
//       window.sessionStorage.clear();
//     }
//   },
//   resetSession({commit, dispatch}) {
//     commit(LoggedOut);
//     // router.push({name:LoginNavigation});
//     commit('cda/clearCda');
//     commit('pdf/clearPdf');
//     commit('report/clearReport');
//     commit('watch/clearAllWatches');
//     //TODO: reset fsm ?
//     window.sessionStorage.clear();
//   },
//   addMeasures({commit}, {externalMeasures,externalMeasCcdMeasIds,externalMeasCcds}) {
//     commit('addMeasures', {externalMeasures,externalMeasCcdMeasIds,externalMeasCcds});
//   } 
// };

// const modules = {
//   cda,
//   pdf,
//   report,
//   watch,
//   provider,
//   preferences
// };

// export default {
//   namespaced: true,
//   state,
//   getters,
//   actions,
//   mutations,
//   modules
// }
import * as sessionApi from '@/api/sessionApi';
import cda from './cda';
import pdf from './pdf';
import report from './report';
import watch from './watch';
import provider from './provider';
import preferences from './preferences';

import { setCsrf, setApplicationModel, LoggedOut, LoggedIn } from '@/mutation-types';
import { RESET_TIMER } from '@/constants/event';

import { ResumeFsm, NoResumeFsm, LoginFailure, LoginNavigation } from './fsm/messages';
import * as messages from './fsm/messages';
import EventBus from '../../event-bus';
import { post } from '@/store/modules/fsm/index';
import router from '@/router/index';
import _ from 'lodash';

// Same dest mapping as router-guard.js (note notification email links).
function resolveDestPath(dest) {
  if (!dest) return null;
  const d = String(dest);
  if (d === "/" || d === "") return "/welcome";
  if (d === "notes") return "/notes";
  if (d === "professional-notes") return "/professional-notes";
  if (d.startsWith("/")) return d;
  return null;
}

import { FEATURES } from '@/config';
import { syncPrivilegesAfterSessionChange } from '@/utils/privilegesSessionSync';
import { isSessionTimeoutError } from '@/api/request';

let { LoggedIn: LoggedInMessage } = messages;

const state = {
  phrData: {
    patient: {}
  },
  is2faVerified: false,
  intendedRoute: null,
  loggedIn: false,
  sessionId: null,  //TODO: sessionId is not used at the moment
  csrf: {
    param: null,
    token: null
  },
  // Tracks whether a user-initiated logout is in progress to suppress timeout alerts
  isLoggingOut: false
};

const getters = {
  getCsrf: state => state.csrf,
  // getAllData: state => state.phrData,
  getAllData: state => {
    // Return the state as is if it exists, or a default object.
    return state.phrData && state.phrData.patient 
      ? state.phrData 
      : { patient: {} };
  },
  isLoggedIn: state => state.loggedIn,
  getSessionId: state => state.sessionId,
  getUser: state => ({ ...state.phrData.user, ...state.phrData.patient }),
  getTaxonomies: state => {
    if (!FEATURES.cda_header_providers) {
      return _.pickBy(state.phrData.taxonomies, taxo => _.some(taxo.npis, npi => state.phrData.npiGroupings[npi]));
    }
    return { ...state.phrData.taxonomies };
  },
  getProviders: state => ({ ...state.phrData.npis }),
  getPatientRelations: state => ({ ...state.phrData.patient.relations }),
  isLoggingOut: state => state.isLoggingOut
};

const mutations = {
  [setCsrf](state, csrf) {
    state.csrf = csrf;
  },
  [setApplicationModel](state, payload) {
    state.phrData = payload;
  },
  [LoggedOut](state) {
    state.phrData = null;
    state.loggedIn = false;
    state.sessionId = null;
    // clear 2FA state on logout
    state.is2faVerified = false;
    state.intendedRoute = null;
  },
  [LoggedIn](state, payload) {
    state.phrData = payload.data;
    state.loggedIn = true;
  },
  setIsLoggingOut(state, value) {
    state.isLoggingOut = !!value;
  },
  // NEW: mutations for 2FA and intended route
  SET_2FA_VERIFIED(state, val) {
    state.is2faVerified = !!val;
  },
  SET_INTENDED_ROUTE(state, route) {
    state.intendedRoute = route || null;
  },
  addMeasures(state, { externalMeasures, externalMeasCcdMeasIds, externalMeasCcds }) {
    state.phrData.measures = { ...state.phrData.measures, ...externalMeasures };
    state.phrData.ccds = { ...state.phrData.ccds, ...externalMeasCcds };

    let measCcdMeasIds = { ...(state.phrData.measCcdMeasIds || {}) };
    for (let measCcd in externalMeasCcdMeasIds) {
      const key = String(measCcd);
      measCcdMeasIds[key] = measCcdMeasIds[key]
        ? _.union(measCcdMeasIds[key], externalMeasCcdMeasIds[measCcd])
        : externalMeasCcdMeasIds[measCcd];
    }
    state.phrData.measCcdMeasIds = measCcdMeasIds;
  }
};

const actions = {
  updateCsrf({ commit }, csrf) {
    commit(setCsrf, csrf);
  },
  inlineUpdateApplicationModel({ commit }, data) {
    commit(setApplicationModel, data);
  },
  // New optional argument to force a full rebuild of the PHR data
  updateApplicationModel({ commit }, opts = {}) {
    const payload = opts && opts.rebuild === true ? { rebuild: true } : null;
    return new Promise((resolve) => {
      sessionApi.getAllData(payload)
        .then(applicationModel => {
          commit(setApplicationModel, applicationModel);
          commit('watch/setExternalMeasuresLoaded', false);
          syncPrivilegesAfterSessionChange();
          resolve();
        })
        .catch(err => console.error(err));
    });
  },
  async showLoginPrompt({ commit }) {
    commit(LoggedOut);
    router.push({ name: LoginNavigation });
  },
  async getInitialMessage({ commit }) {
    let _message = { message: NoResumeFsm };
    try {
      let { data, instance, message, watch: watchValue } = await sessionApi.getInitialMessage();
      if (message && message === 'resumeApplicationMessage') {
        commit('watch/setExternalMeasuresLoaded', false);
        _message = { message: ResumeFsm, data, instance, watch: watchValue };
      }
    } catch (err) {
      if (!isSessionTimeoutError(err)) {
        alert(err);
      }
    }
    await post(_message);

    // New tab: sessionStorage is empty so the router guard may have sent us to /login
    // before the server cookie session is restored. Leave bootstrap/login for welcome.
    if (_message.message === ResumeFsm) {
      commit('SET_2FA_VERIFIED', true);
      const route = router.currentRoute.value;
      const onBootstrapRoute = route.path === '/' || route.path === '/login';
      if (onBootstrapRoute) {
        const intended = resolveDestPath(route.query?.dest) || '/welcome';
        router.replace(intended).catch(() => {});
      }
    }
  },
  async login({ commit }, { loader, patient, password, LoginPage }) {
    let _message = { message: LoginFailure };

    try {
      let response = await sessionApi.login({ patient, password });
      commit('watch/setExternalMeasuresLoaded', false);
      EventBus.emit(RESET_TIMER, { ping: true });
      
      // Commit the login success mutation so that the global auth state is updated
      commit(LoggedIn, { data: response.data }); 

      // Prepare a FSM message indicating login success
      _message = { ...response, message: "LoggedIn" };
      console.log("? Dispatching LoggedIn message:", _message);
      
      // Dispatch the FSM transition (this updates the FSM state)
      await post(_message);

      // After login, require 6-digit auth then redirect to ?dest= if present (else welcome).
      commit('SET_2FA_VERIFIED', false);
      const intended = resolveDestPath(router.currentRoute.value?.query?.dest);
      commit('SET_INTENDED_ROUTE', intended);
      router.push('/sixDigitAuthorization').catch(() => {});
    } catch (err) {
      if (LoginPage) {
        const backendMessage =
          (typeof err === 'string' ? err : null) ||
          err?.response?.data?.message ||
          err?.message ||
          null;
        LoginPage.statusMessage = backendMessage || "Invalid credentials. Please try again.";
      }
      throw err;
    } finally {
      if (loader && typeof loader.hide === "function") {
        loader.hide();
      }
    }
  },

  async logout({ commit }) {
    commit('setIsLoggingOut', true);
    try {
      await sessionApi.logout();
    } catch (err) {
      // Server session may already be expired (e.g. idle timeout); still clear client state.
      console.warn('Logout request failed:', err);
    } finally {
      commit(LoggedOut);
      commit('cda/clearCda');
      commit('pdf/clearPdf');
      commit('report/clearReport');
      commit('watch/clearAllWatches');
      window.sessionStorage.clear();
      commit('setIsLoggingOut', false);
    }
  },
  resetSession({ commit }) {
    commit(LoggedOut);
    commit('cda/clearCda');
    commit('pdf/clearPdf');
    commit('report/clearReport');
    commit('watch/clearAllWatches');
    window.sessionStorage.clear();
  },
  addMeasures({ commit }, { externalMeasures, externalMeasCcdMeasIds, externalMeasCcds }) {
    commit('addMeasures', { externalMeasures, externalMeasCcdMeasIds, externalMeasCcds });
  }
};

const modules = {
  cda,
  pdf,
  report,
  watch,
  provider,
  preferences
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules
};
